import {observer} from "mobx-react";
import {useContext} from "react";
import {OrganizationRecordingsStoreContext, RecordingsStoreContext} from "../stores/RecordingsStore";
import {Header} from "../components/sections/Header";
import {Frame} from "../components/common/Frame";
import {Sessions} from "../components/pages/sessions/Sessions";
import {AppRoutes} from "../AppRoutes";
import {useNavigate} from "react-router";

export const OrganizationSessions = observer(() => {
  const store = useContext(OrganizationRecordingsStoreContext)!;
  const navigate = useNavigate();
  if (!store) return null;
  return <Frame>
    <Header pathCrumbs={[
      [AppRoutes.index, 'Home'],
      [undefined, 'Organization Sessions'],
    ]}
    />
    <Frame contentWidth>
      <RecordingsStoreContext.Provider value={store}>
        <Sessions onSelect={(recording) => {
          if (!recording.id) {
            return;
          }
          navigate(AppRoutes.organizationSessionPath(recording.id));
        }}/>
      </RecordingsStoreContext.Provider>
    </Frame>
  </Frame>;
});
